export default {"src":"/_next/static/media/location_ic.b1e111bf.svg","height":18,"width":13,"blurWidth":0,"blurHeight":0};